"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfTuberculosisScreeningCreateDto = instanceOfTuberculosisScreeningCreateDto;
exports.TuberculosisScreeningCreateDtoFromJSON = TuberculosisScreeningCreateDtoFromJSON;
exports.TuberculosisScreeningCreateDtoFromJSONTyped = TuberculosisScreeningCreateDtoFromJSONTyped;
exports.TuberculosisScreeningCreateDtoToJSON = TuberculosisScreeningCreateDtoToJSON;
exports.TuberculosisScreeningCreateDtoToJSONTyped = TuberculosisScreeningCreateDtoToJSONTyped;
const TuberculosisScreeningWorkHistoryQuestionCreateDto_1 = require("./TuberculosisScreeningWorkHistoryQuestionCreateDto");
const TuberculosisScreeningSymptomCreateDto_1 = require("./TuberculosisScreeningSymptomCreateDto");
/**
 * Check if a given object implements the TuberculosisScreeningCreateDto interface.
 */
function instanceOfTuberculosisScreeningCreateDto(value) {
    if (!('symptoms' in value) || value['symptoms'] === undefined)
        return false;
    if (!('workHistoryQuestions' in value) || value['workHistoryQuestions'] === undefined)
        return false;
    if (!('signature' in value) || value['signature'] === undefined)
        return false;
    return true;
}
function TuberculosisScreeningCreateDtoFromJSON(json) {
    return TuberculosisScreeningCreateDtoFromJSONTyped(json, false);
}
function TuberculosisScreeningCreateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'symptoms': (json['symptoms'].map(TuberculosisScreeningSymptomCreateDto_1.TuberculosisScreeningSymptomCreateDtoFromJSON)),
        'workHistoryQuestions': (json['workHistoryQuestions'].map(TuberculosisScreeningWorkHistoryQuestionCreateDto_1.TuberculosisScreeningWorkHistoryQuestionCreateDtoFromJSON)),
        'signature': json['signature'],
    };
}
function TuberculosisScreeningCreateDtoToJSON(json) {
    return TuberculosisScreeningCreateDtoToJSONTyped(json, false);
}
function TuberculosisScreeningCreateDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'symptoms': (value['symptoms'].map(TuberculosisScreeningSymptomCreateDto_1.TuberculosisScreeningSymptomCreateDtoToJSON)),
        'workHistoryQuestions': (value['workHistoryQuestions'].map(TuberculosisScreeningWorkHistoryQuestionCreateDto_1.TuberculosisScreeningWorkHistoryQuestionCreateDtoToJSON)),
        'signature': value['signature'],
    };
}
//# sourceMappingURL=TuberculosisScreeningCreateDto.js.map